import GarminElevationService from 'views/utils/LeafletMap/MapServices/GarminElevationService';
import PopularityRoutingService from 'views/utils/LeafletMap/MapServices/PopularityRoutingService';
import ConvertService from 'views/utils/LeafletMap/MapServices/ConvertService';

var MapProvider = function() {
        this.name = null;
        this.directionService = null;
        this.locationService = null;
        this.elevationService = new GarminElevationService();
        this.popularityRoutingService = new PopularityRoutingService();
        this.convertService = new ConvertService();
        return this;
    },
    MIN_ZOOM_LEVEL = 3,
    MAX_ZOOM_LEVEL = 18;

//GET METHODS
MapProvider.prototype.getDirectionService = function getDirectionService() {
    return this.directionService;
};

MapProvider.prototype.getLocationService = function getLocationService() {
    return this.locationService;
};

MapProvider.prototype.getElevationService = function getElevationService() {
    return this.elevationService;
};

MapProvider.prototype.getPopularityRoutingService = function getPopularityRoutingService() {
    return this.popularityRoutingService;
};

MapProvider.prototype.getConvertService = function getConvertService() {
    return this.convertService;
};

//UPDATE METHODS
MapProvider.prototype.updateTransitionMode = function updateTransitionMode(transitionMode) {
    if (this.directionService && typeof this.directionService.updateTransitionMode === 'function') {
        this.directionService.updateTransitionMode(transitionMode);
    }
};

MapProvider.prototype.getName = function getName() {
    return this.name;
};

MapProvider.prototype.getSupportedMaxZoom = function getSupportedMaxZoom() {
    return MAX_ZOOM_LEVEL;
};

MapProvider.prototype.getSupportedMinZoom = function getSupportedMinZoom() {
    return MIN_ZOOM_LEVEL;
};

export default MapProvider;
